/** The product app lives on its own origin; the site only links to it. */
export const APP_URL = (process.env.GATSBY_APP_URL || 'https://app.userevaluation.com').replace(/\/$/, '');
export const SIGNUP_URL = `${APP_URL}/signup`;
export const LOGIN_URL = `${APP_URL}/login`;
/** Sign-up with the Participant tab picked: for people who want paid interviews, not to run research. */
export const PARTICIPANT_SIGNUP_URL = `${SIGNUP_URL}?as=participant`;
/** Pages written for participants: their "Start free" buttons sign up participants. */
export const isParticipantPage = (pathname: string) => /^\/(get-paid|participant-consent)(\/|$)/.test(pathname);
/** Sign up for the ambassador programme (or join it with an existing account): the ambassador portal. */
export const AMBASSADOR_URL = `${APP_URL}/ambassador/join`;
/** The API the contact form posts to (`POST /api/public/contact`). */
export const API_URL = (process.env.GATSBY_API_URL || 'https://api.userevaluation.com').replace(/\/$/, '');
export const SUPPORT_EMAIL = 'support@userevaluation.com';
/** Scale, plans and managed-study enquiries. */
export const TERMS_URL = '/terms';
export const PRIVACY_URL = '/privacy';
